import React, { useState } from "react";
import { Radio, Space, Tabs } from "antd";
import { TbCaretRight } from "react-icons/tb";
import "./Work.css";
import "../../index.css";
import { color } from "framer-motion";
import assImage from "../../Assets/download.png";
import { MainProject } from "../MainProject/MainProject";
import OtherProject from "../OtherProject/OtherProject";
import MobileMainProject from "../MainProject/MobileMainProject";
// import { OtherProject } from "../OtherProject/OtherProject";

export const Work = () => {
  return (
    <div className=" w-full">
      <MainProject />
      <MobileMainProject />
      <OtherProject></OtherProject>
    </div>
  );
};
